import React from 'react';
import { CheckIcon } from 'lucide-react';
interface FeaturePointA1Props {
  children: React.ReactNode;
}
const FeaturePointA1 = ({
  children
}: FeaturePointA1Props) => {
  return <div className="flex items-start" data-id="element-6029">
      <div className="flex-shrink-0 mt-1" data-id="element-6030">
        <CheckIcon className="h-4 w-4 text-gray-700" data-id="element-6031" />
      </div>
      <div className="ml-2 text-sm text-gray-700" data-id="element-6032">{children}</div>
    </div>;
};
export default FeaturePointA1;